<template>
  <v-card :flat="references.cardFlat !== undefined ? references.cardFlat : false">
    <v-form ref="validateForm" autocomplete="off">
      <v-card-title primary-title :class="references.cardTitleClass !== undefined ? references.cardTitleClass : 'px-2 py-1'" v-if="references.title">
        <h5> {{ references.title }} </h5>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider v-if="references.title"></v-divider>
      <v-container fluid grid-list-xl>
        <v-layout wrap :class="references.layoutClass !== undefined ? references.layoutClass : 'px-0 py-1'">
          <template v-for="(prop, index) in references.properties">
            <v-flex v-if="prop.is_show !== undefined ? prop.is_show : true" :class="['form-col', prop.class]" :key="index" :style="prop.style">
              <template v-if="prop.type === formType.TEXT">
                <v-text-field outlined :maxlength="prop.max ? prop.max : ''" hide-details="auto" :label="prop.label" :suffix="prop.suffix" :id="prop.model" :ref="prop.ref" @input="prop.input" :disabled="prop.disabled" :rules="prop.rules" v-model="model[prop.model]" dense @change="prop.change ? prop.change() : ''"
                  :append-icon="prop.appendIcon !== undefined ? prop.appendIcon : ''" @click:append="prop.appendClick !== undefined ? prop.appendClick() : null"
                  :readonly="prop.readonly"></v-text-field>
              </template>
              <template v-if="prop.type === formType.NUMBER">
                <v-text-field outlined hide-details="auto" :type="formType.NUMBER" inputmode="decimal" :suffix="prop.suffix" :id="prop.model" :label="prop.label" :rules="prop.rules" v-model="model[prop.model]" :disabled="prop.disabled" dense> </v-text-field>
              </template>
              <template v-else-if="prop.type === formType.TEXTAREA">
                <v-textarea outlined hide-details="auto" :label="prop.label" :id="prop.model"
                  :rules="prop.rules" v-model="model[prop.model]" :disabled="prop.disabled" :readonly="prop.readonly !== undefined ? prop.readonly : false " :rows="prop.rows" :auto-grow="prop.autoGrow === true" dense  @change="prop.change ? prop.change() : ''"></v-textarea>
                  <label v-if="prop.showHint" :for="prop.model" class="v-label" :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"><v-icon small>mdi-information-outline</v-icon> {{prop.hintMsg}}</label>
              </template>
              <template v-else-if="prop.type === formType.CHECKBOX">
                <v-checkbox hide-details="auto" :label="prop.label" :id="prop.model" color="primary" :rules="prop.rules" v-model="model[prop.model]" @change="prop.click ? prop.click(prop.model): ''" :disabled="prop.disabled"> </v-checkbox>
              </template>
              <template v-else-if="prop.type === formType.AUTO_COMPLETE">
                <v-autocomplete outlined hide-details="auto" :items="prop.items" :id="prop.model" :disabled="prop.disabled" dense
                  :rules="prop.rules" :item-text="prop.select_text" :multiple="prop.multiple" autocomplete="off"
                  @click:append="prop.click(prop.term)"
                  :item-value="prop.select_value" :label="prop.label"
                  :ref="prop.term? '' + prop.term : ''"
                  :append-icon="prop.is_list ? 'add_circle' : ''"
                  clearable
                  @change="prop.change ? prop.change() : ''"
                  v-model="model[prop.model]">
                  <template v-slot:selection="{ item, index }" v-if="prop.multiple">
                    <span v-if="index === 0">{{ item[prop.select_text] }}</span>
                    <span
                      v-if="index === 1"
                      class="grey--text caption"
                    >(+{{ model[prop.model].length - 1 }} {{ $t('message.common.others') }})</span>
                  </template>
                </v-autocomplete>
                <span v-if="prop.helpTextShow && prop.helpText">{{ prop.helpText }}</span>
              </template>
              <template v-else-if="prop.type === formType.SELECT">
                <v-select outlined hide-details="auto" :items="prop.items" :id="prop.model" :rules="prop.rules" :item-text="prop.select_text" dense :multiple="prop.multiple" :item-value="prop.select_value" :label="prop.label" :disabled="prop.disabled" v-model="model[prop.model]" @change="prop.change ? prop.change() : ''" @click="prop.click ? prop.click(): ''">
                  <template v-slot:prepend-item v-if="prop.select_all">
                    <v-list-item @click="handleSelectAll(index)">
                      <v-list-item-action>
                        <v-icon color="primary"> {{selectAllIcon(index)}} </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ $t('message.projects.all') }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </template>
              <template v-else-if="prop.type === formType.PASSWORD">
                <v-text-field outlined hide-details="auto" :label="prop.label" :id="prop.model" :rules="prop.rules" :type="formType.PASSWORD" v-model="model[prop.model]" dense> </v-text-field>
              </template>
              <template v-else-if="prop.type === formType.COMBOBOX">
                <div class="combo">
                  <v-combobox v-model="model[prop.model]" @change="prop.change ? prop.change() : ''" :items="prop.items" hide-selected  :rules="prop.rules" :label="prop.label" :multiple="prop.multiple" persistent-hint small-chips :id="prop.model" :disabled="prop.disabled" outlined dense hide-details="auto"></v-combobox>
                </div>
              </template>
              <template v-else-if="prop.type === formType.DATEPICKER">
                <v-menu :close-on-content-click="false" v-model="model[prop.menu]" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined hide-details="auto" v-model="model[prop.model]" :rules="prop.rules" clearable :label="prop.label" :placeholder="prop.placeholder" prepend-inner-icon="mdi-calendar" dense
                    readonly v-on="on" :disabled="prop.disabled" @click:clear="$nextTick(() => model[prop.picker] = null)"></v-text-field>
                  </template>
                  <v-date-picker :color="prop.color" @input="model[prop.menu] = false; model[prop.model] = $formatter.formatDate(model[prop.picker], 'YYYY-MM-DD', 'DD.MM.YYYY')" :min="model[prop.min]" :max="model[prop.max]" v-model="model[prop.picker]" first-day-of-week='1'
                    :disabled="prop.disabled" :weekday-format="getDayFormat"></v-date-picker><!-- :locale="getLocale"  -->
                </v-menu>
              </template>
              <template v-else-if="prop.type === formType.DATETIMEPICKER">
                <slot :name="prop.slot"></slot>
              </template>
              <template v-else-if="prop.type === formType.QUICKADD">
                <v-btn fab small outline color="primary" :id="prop.type" @click="$router.push(prop.to)" :disabled="prop.disabled">
                  <v-icon color="primary">perm_identity</v-icon>
                </v-btn>
              </template>
              <template v-else-if="prop.type === formType.TIMEPICKER">
                <v-menu :close-on-content-click="false" :ref="prop.menu" v-model="model[prop.menu]" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field  outlined hide-details="auto" slot="activator" :label="prop.label" :rules="prop.rules" dense v-model="model[prop.model]" readonly v-on="on" prepend-inner-icon="mdi-clock-outline" clearable :disabled="prop.disabled"></v-text-field>
                  </template>
                  <v-time-picker color="primary" v-model="model[prop.model]" :min="setMin(model[prop.min])" :max="model[prop.max]" @click:minute="$refs[prop.menu][0].save(model[prop.model])" :allowed-minutes="allowedStep" format="24hr" :disabled="prop.disabled"></v-time-picker>
                </v-menu>
              </template>
              <template v-else-if="prop.type === formType.FILES">
                <div class="d-flex align-center">
                  <div class="flex-grow-1">
                    <!-- iOS Safari gets a native file input; the Vuetify props it used to carry were inert on a bare <input>,
                         so the label and outline are supplied by this wrapper instead. -->
                    <div v-if="isIos" class="ios-file">
                      <label class="ios-file__label" :for="prop.id ? prop.id : 'file-' + prop.model">
                        {{ prop.label }}
                      </label>
                      <input
                        type="file"
                        class="ios-file__input"
                        :id="prop.id ? prop.id : 'file-' + prop.model"
                        :accept="getAcceptedFileTypes(prop)"
                        :disabled="prop.disabled"
                        :multiple="prop.multiple"
                        @change="handleFileUpload($event, prop)" />
                    </div>
                    <v-file-input v-else prepend-inner-icon="mdi-paperclip" @change="handleVFileChange($event, prop)" prepend-icon="" :accept="getAcceptedFileTypes(prop)" hide-details="auto" :disabled="prop.disabled" outlined v-model="model[prop.model]" :rules="prop.rules" :label="prop.label" :multiple="prop.multiple" dense></v-file-input>
                  </div>
                  <camera-upload-modal
                    v-if="prop.multiple"
                    :readonly="prop.disabled"
                    :label="prop.label"
                    :file-prefix="(prop.slot ? prop.slot.replace('_documents', '') : 'camera') + '-photo'"
                    @upload-success="(file) => handleCameraUpload(file, prop)"
                  />
                </div>
                <slot :name="prop.slot"></slot>
              </template>
              <template v-else-if="prop.type === 'warehouse_product_batchno'">
                <slot :name="prop.slot"></slot>
              </template>
              <template v-else-if="prop.type === 'use_consumable'">
                <slot :name="prop.slot"></slot>
              </template>
              <template v-else-if="prop.type === 'weld_end_complete'">
                <slot :name="prop.slot"></slot>
              </template>
              <template v-else-if="prop.type === formType.COLORPICKER">
                <v-menu bottom :close-on-content-click="false" offset-y v-model="model[prop.menu]">
                  <template v-slot:activator="{ on }">
                    <v-text-field :label="prop.label" v-model="model[prop.model]" outlined hide-details="auto" class="ma-0 pa-0" readonly slot="activator" v-on="on" :disabled="prop.disabled" dense></v-text-field>
                  </template>
                  <v-color-picker v-if="[prop.menu]" v-model="model[prop.model]" bottom flat :disabled="prop.disabled" />
                </v-menu>
              </template>
              <template v-else-if="prop.type === formType.RADIO && prop.is_show">
                <v-radio-group v-model="model[prop.model]" row @change="prop.click ? prop.click(prop.model): ''">
                  <template v-for="items in prop.items">
                    <v-radio :label="items.text" :value="items.value" :key="items.value"></v-radio>
                  </template>
                </v-radio-group>
              </template>
              <template v-else-if="prop.type === 'section'">
                <div class="form-section">
                  <span class="form-section__label">{{ prop.label }}</span>
                  <span class="form-section__rule"></span>
                </div>
              </template>
            </v-flex>
          </template>
        </v-layout>
      </v-container>
      <v-card-text class="pa-0">
        <slot name="extraDetails"></slot>
      </v-card-text>
      <v-divider v-if="references.buttons.length > 0"></v-divider>
      <v-card-actions v-if="references.buttons">
        <v-spacer></v-spacer>
        <v-layout justify-center>
          <v-flex>
            <template v-for="(button, index) in references.buttons">
              <v-btn :key="index" :loading="button.loading" :id="button.name" v-if="button.is_show" @click="button.click" color="primary" :disabled="button.disabled" class="mr-2"> {{ button.label }} </v-btn>
            </template>
          </v-flex>
        </v-layout>
      </v-card-actions>
      <slot name="button" v-else></slot>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import CameraUploadModal from '@/components/CameraUploadModal'
import { snapshotModel, sameSnapshot } from '@/utils/formDirty'
import { MARK_DIRTY, MARK_CLEAN } from '@/store/mutationsTypes'

// The first of these (trusted, inside the form) ends the loading phase.
const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'input', 'change']

/*
 * Unsaved changes (store unsavedChanges; blocks automatic app updates).
 * The parent owns `model` and this form changes it in place, so the form
 * compares snapshots of it. Until the user first touches the form, every
 * change is loading or defaults and becomes the new baseline. After that the
 * form is dirty while the model differs from the baseline, and clean again
 * when the user reverts. A new model object from the parent (record loaded,
 * reset after saving) starts over clean. Parents that stay on the page after
 * saving without replacing the model call this.$refs.<form>.markSaved().
 */
export default {
  props: {
    references: {
      type: Object
    },
    model: {
      type: Object
    }
  },
  data () {
    return {
      isIos: false,
      allowedFileExtensions: ['jpg', 'jpeg', 'gif', 'bmp', 'png', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'ppt', 'pptx', 'txt', 'csv', 'msg', 'eml', 'dwg', 'dxf', 'ifc', 'glb', 'obj', 'ply', 'svg']
    }
  },
  computed: {
    ...mapGetters(['formType']),
    acceptedFileTypes () {
      return this.allowedFileExtensions.map(ext => '.' + ext).join(',')
    },
    getAcceptedFileTypes () {
      return (prop) => {
        const extras = Array.isArray(prop && prop.extraExtensions) ? prop.extraExtensions : []
        return [...this.allowedFileExtensions, ...extras].map(ext => '.' + ext).join(',')
      }
    },
    getLocale () {
      return this.$i18n.locale === 'no' ? 'no-NO' : 'en-US'
    },
    // Date fields keep their menu-open flag and picker value in the model.
    ignoredModelKeys () {
      const properties = (this.references && this.references.properties) || []
      return properties.reduce((keys, prop) => {
        if (prop && prop.menu) keys.push(prop.menu)
        if (prop && prop.picker) keys.push(prop.picker)
        return keys
      }, [])
    },
    selectAllIcon () {
      return index => {
        const modelLength = Array.isArray(this.model[this.references.properties[index].model]) ? this.model[this.references.properties[index].model].length : 0
        const itemsLength = this.references.properties[index].items.length
        if (modelLength === itemsLength) return 'mdi-close-box'
        if (modelLength) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      }
    }
  },
  watch: {
    model: {
      deep: true,
      handler (model, previous) {
        if (model !== previous) {
          this.userInteracted = false
          this.markSaved()
          return
        }
        this.checkDirty()
      }
    },
    ignoredModelKeys () {
      this.checkDirty()
    }
  },
  created () {
    window.addEventListener('resize', this.checkDeviceName)
    // Not reactive on purpose: only the store needs to know.
    this.dirtyId = `form-template-${this._uid}`
    this.isDirty = false
    this.userInteracted = false
    this.dirtyBaseline = snapshotModel(this.model)
  },
  beforeDestroy () {
    INTERACTION_EVENTS.forEach(type => this.$el.removeEventListener(type, this.onUserInteraction, true))
  },
  destroyed () {
    window.removeEventListener('resize', this.checkDeviceName)
    this.setDirty(false)
  },
  mounted () {
    const userAgent = window.navigator.userAgent.toLowerCase() || navigator.userAgent.toLowerCase() || navigator.vendor.toLowerCase() || navigator.platform.toLowerCase()
    this.isIos = (/iphone|ipad|ipod/.test(userAgent)) || (/macintosh/.test(userAgent) && 'ontouchend' in document)
    INTERACTION_EVENTS.forEach(type => this.$el.addEventListener(type, this.onUserInteraction, true))
  },
  methods: {
    onUserInteraction (event) {
      if (!event.isTrusted || this.userInteracted) return
      // Capture phase: runs before this interaction changes the model. Also
      // picks up values the parent added on non-reactive keys while loading.
      this.dirtyBaseline = snapshotModel(this.model)
      this.userInteracted = true
    },
    checkDirty () {
      const snapshot = snapshotModel(this.model)
      if (!this.userInteracted) {
        this.dirtyBaseline = snapshot
        return
      }
      this.setDirty(!sameSnapshot(snapshot, this.dirtyBaseline, this.ignoredModelKeys))
    },
    // Public: the current values are saved.
    markSaved () {
      this.dirtyBaseline = snapshotModel(this.model)
      this.setDirty(false)
    },
    setDirty (dirty) {
      if (dirty === this.isDirty) return
      this.isDirty = dirty
      this.$store.commit(`unsavedChanges/${dirty ? MARK_DIRTY : MARK_CLEAN}`, this.dirtyId)
    },
    allowedStep: m => m % 5 === 0,
    getDayFormat (date) {
      const lang = this.$i18n.locale === 'no' ? 'nb' : 'en'
      return moment(date).locale(lang).format('dd')
      // return dayString.charAt(0).toUpperCase() + dayString.slice(1)
    },
    setMin (time) {
      if (time) time = moment(time, 'HH:mm').add(5, 'minutes').format('HH:mm')
      return time
    },
    isAllowedFile (file, prop) {
      if (!file || !file.name) return false
      const ext = file.name.split('.').pop().toLowerCase()
      const extras = Array.isArray(prop && prop.extraExtensions) ? prop.extraExtensions : []
      return this.allowedFileExtensions.includes(ext) || extras.includes(ext)
    },
    notifyInvalidFiles (names) {
      if (!names.length) return
      this.$root.$emit('snackbar', {
        snackbar: true,
        color: 'error',
        text: this.$t('message.checklist.invalidFileType') + ': ' + names.join(', ')
      })
    },
    handleFileUpload (event, prop) {
      const files = Array.from(event.target.files || [])
      const valid = files.filter(f => this.isAllowedFile(f, prop))
      const invalid = files.filter(f => !this.isAllowedFile(f, prop)).map(f => f.name)
      this.notifyInvalidFiles(invalid)
      if (!valid.length) {
        event.target.value = ''
        this.$set(this.model, prop.model, prop.multiple ? [] : null)
      } else {
        this.$set(this.model, prop.model, prop.multiple ? valid : valid[0])
      }
      if (prop.change) prop.change()
    },
    handleVFileChange (files, prop) {
      const list = Array.isArray(files) ? files : (files ? [files] : [])
      const valid = list.filter(f => this.isAllowedFile(f, prop))
      const invalid = list.filter(f => !this.isAllowedFile(f, prop)).map(f => f.name)
      if (invalid.length) {
        this.notifyInvalidFiles(invalid)
        this.$set(this.model, prop.model, prop.multiple ? valid : (valid[0] || null))
      }
      if (prop.change) prop.change()
    },
    checkDeviceName (e) {
      const userAgent = window.navigator.userAgent.toLowerCase() || navigator.userAgent.toLowerCase() || navigator.vendor.toLowerCase() || navigator.platform.toLowerCase()
      this.isIos = (/iphone|ipad|ipod/.test(userAgent)) || (/macintosh/.test(userAgent) && 'ontouchend' in document)
    },
    handleSelectAll (index) {
      this.$nextTick(() => {
        const modelLength = Array.isArray(this.model[this.references.properties[index].model]) ? this.model[this.references.properties[index].model].length : 0
        const itemsLength = this.references.properties[index].items.length
        // $set: on a new record the key may not exist yet, and a plain
        // assignment would add it without reactivity (unsaved changes too).
        if (modelLength !== itemsLength) {
          this.$set(this.model, this.references.properties[index].model, this.references.properties[index].select_value ? this.references.properties[index].items.map(x => x[this.references.properties[index].select_value]) : this.references.properties[index].items)
        } else {
          this.$set(this.model, this.references.properties[index].model, [])
        }
        this.$forceUpdate()
      })
    },
    handleCameraUpload (file, prop) {
      const modelKey = prop.model
      if (!this.model[modelKey]) {
        this.$set(this.model, modelKey, [file])
      } else {
        const currentFiles = Array.isArray(this.model[modelKey]) ? [...this.model[modelKey]] : []
        currentFiles.push(file)
        this.$set(this.model, modelKey, currentFiles)
      }
      this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: 'Photo added successfully' })
    }
  },
  components: {
    'camera-upload-modal': CameraUploadModal
  }
}
</script>
<style scoped>
/* was: .container.grid-list-xl .layout .flex { padding: 7px !important; }
   dead rule — the inline padding on v-flex always won. */
.container.grid-list-xl .layout .flex.form-col {
  padding: 5px;
}

/* --- section heading --- */
.form-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 10px 0 0;
}
.form-section__label {
  font-size: 13px;
  font-weight: 600;
  opacity: 0.72;
  white-space: nowrap;
}
.form-section__rule {
  flex: 1 1 auto;
  height: 1px;
  background: currentColor;
  opacity: 0.16;
}

/* --- native file input on iOS --- */
.ios-file {
  display: flex;
  flex-direction: column;
}
.ios-file__label {
  font-size: 12px;
  opacity: 0.7;
  margin-bottom: 4px;
}
.ios-file__input {
  min-height: 48px;
  width: 100%;
  padding: 12px;
  border: 1px solid rgba(128, 128, 128, 0.5);
  border-radius: 4px;
  font: inherit;
  color: inherit;
  background: transparent;
}
.ios-file__input:disabled {
  opacity: 0.5;
}
</style>
